import { addSeconds } from 'date-fns';
import { ERROR, FETCH_DEVICE, FETCH_DEVICE_EVENTS, FETCH_DEVICE_EVENTS_AND_LOGS, CLEAR_DEVICE } from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { deviceLogEventTypeSet } from './log';
import { getRequestOptions, getDateRange } from '#helper';
import { history } from '#configureStore';

function error(err) {
  return {
    type: ERROR,
    payload: err
  };
}

export function fetchDevice({ deviceId }, callback) {
  return dispatch => {
    fetch(
      webPortalApi.buildApiUrl(`device/distinct/${deviceId}`),
      getRequestOptions()
    )
      .then(r => {
        r.json().then(data => {
          if (!r.ok) {
            return dispatch(
              error({
                message: 'HTTP error occurred',
                ...data
              })
            );
          }

          dispatch({
            type: FETCH_DEVICE,
            payload: data
          });
          return callback();
        });
      })
      .catch(() =>
        dispatch(
          error({
            message: 'Error in request'
          })
        ));
  };
}

export function fetchEvents({ deviceId }, period) {
  return dispatch => {
    let eventsURI = webPortalApi.buildApiUrl(`device/distinct/${deviceId}/events`);

    if (period) {
      const { start, end } = period;
      const range = getDateRange(start, end);
      eventsURI += `/${range.start}/${range.end}`;
    }

    return fetch(eventsURI, getRequestOptions())
      .then(r =>
        r.json().then(data => {
          if (!r.ok) {
            return dispatch(
              error({
                message: 'HTTP error occurred',
                ...data
              })
            );
          }
          return dispatch({
            type: FETCH_DEVICE_EVENTS,
            payload: data
          });
        }))
      .catch(() =>
        dispatch(
          error({
            message: 'Error in request'
          })
        ));
  };
}

export const fetchDeviceLogs = ({ deviceId }, period) => async dispatch => {
  try {
    const date = new Date();
    const defaultDateRange = {
      start: new Date(date - 24 * 60 * 60 * 1000).toISOString(),
      end: date.toISOString()
    };

    const periodEnd = addSeconds(new Date(period?.end), 10);
    const dateRange = period ? {
      start: period?.start,
      end: periodEnd.toISOString()
    } : defaultDateRange;

    const deviceLogUrlParams = new URLSearchParams({ device: deviceId, event: [...deviceLogEventTypeSet], order: 'ASC', ...dateRange });
    const deviceLogUrl = webPortalApi.buildApiUrl(`log?${deviceLogUrlParams.toString()}`);

    const deviceLogResponse = await fetch(deviceLogUrl, getRequestOptions());
    const paginatedLogs = await deviceLogResponse.json();

    const logs = paginatedLogs?.logs ?? [];

    return (
      dispatch({
        type: FETCH_DEVICE_EVENTS_AND_LOGS,
        payload: { logs }
      })
    );
  } catch (err) {
    return (
      dispatch(
        error({
          message: err
        })
      )
    );
  }
};

export const fetchDeviceData = ({ deviceId }) => async dispatch => {
  try {
    const path = `device/distinct/${deviceId}`;
    const res = await fetch(webPortalApi.buildApiUrl(path), getRequestOptions());

    const response = await res.json();

    if (!res.ok) {
      const shallRedirect = [403, 404].includes(res.status);

      if (shallRedirect) {
        await history.push('/device');
      }

      throw response;
    }

    return dispatch({
      type: FETCH_DEVICE,
      payload: response
    });
  } catch (e) {
    dispatch(
      error({
        message: 'Error in request',
        ...e
      })
    );

    return e;
  }
};

export const clearDevice = () => dispatch => {
  dispatch({
    type: CLEAR_DEVICE
  });
};
